import SpacePurposesTable from "./SpacePurposesTable";
import SpaceNames from "./SpaceNames";
import SubSpaceNames from "./SubSpaceNames";

export { SpacePurposesTable, SpaceNames, SubSpaceNames };
